<template>
  <div class="hero" id="hero">
    <img style="  z-index: 15;position:relative;"
         src="/ru/lg-signature/pushkinmuseum/images/desktop/hero/hero1.jpg">
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide hero-slide">
          <p>Искусство вдохновляет <span>технологии.</span></p>
        </div>
        <div class="swiper-slide hero-slide">
          <p>Технологии дополняют <span>искусство</span></p>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: [''],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },

  mounted() {
  },
  methods: {},
  computed: {}
}
</script>
<style lang="scss">
@import "hero.scss";
</style>
